import { z } from 'zod'

export const paymentCurrentPlanSchema = z
  .object({
    amount: z.number(),
    name: z.string(),
    next_payment_date: z.number(),
    currency: z.string(),
  })
  .nullable()
export type PaymentCurrentPlanType = z.infer<typeof paymentCurrentPlanSchema>

export const paymentCurrentPlanDTO = (
  data: unknown
): PaymentCurrentPlanType => {
  const safeParse = paymentCurrentPlanSchema.safeParse(data)

  if (safeParse.error) {
    console.log(safeParse.error, data)
    throw new Error(safeParse.error.message)
  }

  return safeParse.data
}
